import { calmTokens as t } from '../../shared/tokens';
import { fmtEUR } from '../../shared/format';
import { IconSparkle } from '../../shared/icons';
import CalmMonthPicker from '../transactions/CalmMonthPicker';

export default function ForecastHero({
  month,
  year,
  monthLabelLow,
  forecastBalance,
  forecastPositive,
  pendingCount,
  onMonthChange,
}) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 40,
        marginBottom: 32,
        flexWrap: 'wrap',
      }}
      className="calm-forecast-hero"
    >
      <div style={{ minWidth: 0, flex: '1 1 auto' }}>
        <div
          className="calm-hero-greeting"
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 7,
            fontSize: 13,
            color: t.textDim,
            marginBottom: 10,
          }}
        >
          <IconSparkle size={13} style={{ color: t.accent }} />
          <span>Prévisions · fin {monthLabelLow}</span>
        </div>
        <h1
          style={{
            fontFamily: t.fontDisp,
            fontSize: 'var(--hero-size)',
            fontWeight: 400,
            letterSpacing: -1,
            margin: 0,
            lineHeight: 1.15,
            color: t.text,
          }}
        >
          Vous finirez le mois avec{' '}
          <span
            style={{
              fontStyle: 'italic',
              color: forecastPositive ? t.credit : t.debit,
            }}
          >
            {fmtEUR(forecastBalance, { sign: forecastBalance < 0 })}
          </span>
          .
        </h1>
        <p
          className="calm-hero-sub"
          style={{
            fontSize: 14,
            color: t.textDim,
            margin: '10px 0 0',
            letterSpacing: -0.1,
            maxWidth: 560,
          }}
        >
          {pendingCount === 0
            ? 'Plus aucune opération récurrente à venir ce mois-ci.'
            : `Sur la base des ${pendingCount} opération${pendingCount > 1 ? 's' : ''} récurrente${pendingCount > 1 ? 's' : ''} encore à venir ce mois-ci.`}
        </p>
      </div>

      {onMonthChange && (
        <CalmMonthPicker month={month} year={year} onChange={onMonthChange} />
      )}
    </div>
  );
}
